import React, {useState} from "react";
import * as THREE from "three";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader"
import {useLoader, useFrame} from "@react-three/fiber";
import {useRef, useEffect } from "react";
import { useSpring, animated } from 'react-spring'

const INITIAL_MTL = new THREE.MeshPhongMaterial({
    color: new THREE.Color(0xf1f1f1),
    shininess: 10
});

const INITIAL_ARROW_MTL = new THREE.MeshPhongMaterial({
    color: new THREE.Color(0xffffff),
    opacity: 0.0,
    transparent: true
});

const VISIBLE_ARROW_MTL = new THREE.MeshPhongMaterial({
    color: new THREE.Color(0x5170E7),
    opacity: 0.0,
    transparent: true
});

const INITIAL_MAP = [
    {childID: "alternative", mtl: INITIAL_MTL},
    {childID: "art", mtl: INITIAL_MTL},
    {childID: "australian", mtl: INITIAL_MTL},
    {childID: "australiana", mtl: INITIAL_MTL},
    {childID: "buddhism", mtl: INITIAL_MTL},
    {childID: "cassettes", mtl: INITIAL_MTL},
    {childID: "CDs", mtl: INITIAL_MTL},
    {childID: "chemistry", mtl: INITIAL_MTL},
    {childID: "classics", mtl: INITIAL_MTL},
    {childID: "collectors", mtl: INITIAL_MTL},
    {childID: "comics", mtl: INITIAL_MTL},
    {childID: "cooking", mtl: INITIAL_MTL},
    {childID: "crime", mtl: INITIAL_MTL},
    {childID: "detective", mtl: INITIAL_MTL},
    {childID: "display", mtl: INITIAL_MTL},
    {childID: "DVDs", mtl: INITIAL_MTL},
    {childID: "ecology", mtl: INITIAL_MTL},
    {childID: "family", mtl: INITIAL_MTL},
    {childID: "fantasy", mtl: INITIAL_MTL},
    {childID: "fashion", mtl: INITIAL_MTL},
    {childID: "feminism", mtl: INITIAL_MTL},
    {childID: "film", mtl: INITIAL_MTL},
    {childID: "foreignLanguage", mtl: INITIAL_MTL},
    {childID: "garden", mtl: INITIAL_MTL},
    {childID: "generalFiction", mtl: INITIAL_MTL},
    {childID: "geology", mtl: INITIAL_MTL},
    {childID: "guitarMags", mtl: INITIAL_MTL},
    {childID: "health", mtl: INITIAL_MTL},
    {childID: "history", mtl: INITIAL_MTL},
    {childID: "homecraft", mtl: INITIAL_MTL},
    {childID: "horror", mtl: INITIAL_MTL},
    {childID: "historical", mtl: INITIAL_MTL},
    {childID: "kids", mtl: INITIAL_MTL},
    {childID: "magazines", mtl: INITIAL_MTL},
    {childID: "martialArts", mtl: INITIAL_MTL},
    {childID: "math", mtl: INITIAL_MTL},
    {childID: "modernClassics", mtl: INITIAL_MTL},
    {childID: "nature", mtl: INITIAL_MTL},
    {childID: "photography", mtl: INITIAL_MTL},
    {childID: "physics", mtl: INITIAL_MTL},
    {childID: "poetry/plays", mtl: INITIAL_MTL},
    {childID: "politics", mtl: INITIAL_MTL},
    {childID: "scifi", mtl: INITIAL_MTL},
    {childID: "speculative", mtl: INITIAL_MTL},
    {childID: "sheetMusic", mtl: INITIAL_MTL},
    {childID: "space", mtl: INITIAL_MTL},
    {childID: "sport", mtl: INITIAL_MTL},
    {childID: "textbooks", mtl: INITIAL_MTL},
    {childID: "theology", mtl: INITIAL_MTL},
    {childID: "trade", mtl: INITIAL_MTL},
    {childID: "travel", mtl: INITIAL_MTL},
    {childID: "trueCrime", mtl: INITIAL_MTL},
    {childID: "trueWar", mtl: INITIAL_MTL},
    {childID: "vinyl", mtl: INITIAL_MTL},
    {childID: "vinylDisplay", mtl: INITIAL_MTL},
    {childID: "westerns", mtl: INITIAL_MTL},
];

const initColor = (parent, type, mtl) => {
    parent.traverse(o => {
        if (o.isMesh && o.name.includes(type)) {
            o.castShadow = true;
            o.receiveShadow = true;
            o.material = mtl;
            o.nameID = type;
        }
    });
}



function indicator() {

}

const ShopMesh = ({newMaterialOpt}) => {
    const {scene: theModel} = useLoader(GLTFLoader, "rices.gltf");
    const shop = useRef(theModel)

    const {scene: theArrow} = useLoader(GLTFLoader, "rices_arrow.gltf");
    const the_arrow = useRef(theArrow)

    const [arrowFade, fadeInArrow] = useState(false);

    var fadeIn = false;

    var arrowX = 0.0;
    var arrowY = 0.0;
    var arrowZ = 0.0;

    theArrow.traverse(s => {
        s.material = INITIAL_ARROW_MTL
    })

    useEffect(() =>
            void setMaterial(newMaterialOpt.activeOption, newMaterialOpt.newMTL)
        , [newMaterialOpt.newMTL])

    useEffect(() => {
        if (theModel) {
            for (let object of INITIAL_MAP) {
                initColor(theModel, object.childID, object.mtl);
            }
        }
    }, [theModel])

    const setMaterial = (type, mtl) => {
        theModel.traverse(o => {
            if (o.isMesh && o.nameID != null) {
                if (o.nameID === type) {
                    o.material = mtl;
                    arrowX = o.position.x;
                    arrowZ = o.position.z;
                } else {
                    o.material = new THREE.MeshPhongMaterial({
                        color: parseInt("0xFFFFFF"),
                      });
                }
            }
        });
        theArrow.position.x = arrowX;
        theArrow.position.z = arrowZ;
        fadeIn = true;
        theArrow.traverse(s => {
            s.material = VISIBLE_ARROW_MTL;
        })
    }

    useFrame((state) => {
        const t = state.clock.getElapsedTime()
        const peak = Math.sin(t)/2
        theArrow.position.y = peak + 1
        if (fadeIn && theArrow.material.opacity < 1) {
            theArrow.material.opacity = theArrow.material.opacity + 0.03;
        }
    })


    return (
    <><primitive
        ref={shop}
        object={theModel}
        scale={[1,1,1]}
        rotation={new THREE.Euler(0, 0, 0)}
        position={[0, 0, 0]}
        receiveShadow
    >
    </primitive>
    <primitive
        ref={the_arrow}
        object={theArrow}
        scale={[1,1,1]}
        rotation={new THREE.Euler(0, 0, 0)}
        position={[0, 0, 0]}
    >
    </primitive>
    </>
    )

}

export default ShopMesh;